import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Home from '../../views/home/home';
import User from '../../views/user/user';
// import LanguageList from '../../views/language-list/language-list';
import Baggage from '../../views/baggage/baggage';
import SelectionBaggage from '../../views/baggage/selection-baggage/selection-baggage';
import DeliveryBaggage from '../../views/baggage/delivery-baggage/delivery-baggage';
import ConfirmBaggage from '../../views/baggage/confirm-baggage/confirm-baggage';
import Error from '../../views/error/error';
import NotFound from '../../views/not-found/not-found';
import DescriptionBaggage from '../../views/baggage/description-baggage/description-baggage'
import Refund from '../../views/refund/refund';
import ContactUs from  '../../views/contact-us/contact-us';
import ChooseStore from  '../../views/choose-store/choose-store';
import { environment } from '../../environments/environment';

// Componente para detectar y redirigir a Vueling
const VuelingRedirectWrapper = ({ match, component: Component, ...rest }) => {
  if (match.params.company === 'vueling') {
    window.location.href = environment.redirects.vueling;
    return null;
  }
  return <Component match={match} {...rest} />;
};

const Root = () => (
  <Router>
    {/* <Switch> */}
    <Route path="/:company" render={(props) => <VuelingRedirectWrapper {...props} component={Home} />} />
    {/* <Route path="/:company/languages" component={LanguageList} /> */}
    <Route path="/:company/error" render={(props) => <VuelingRedirectWrapper {...props} component={Error} />} />
    <Route path="/:company/pir" render={(props) => <VuelingRedirectWrapper {...props} component={User} />} />
    <Route path="/:company/refund" render={(props) => <VuelingRedirectWrapper {...props} component={Refund} />} />
    <Route path="/:company/contact-us" render={(props) => <VuelingRedirectWrapper {...props} component={ContactUs} />} />
    <Route path="/:company/choose-store" render={(props) => <VuelingRedirectWrapper {...props} component={ChooseStore} />} />
    <Route exact path="/:company/baggage" render={(props) => <VuelingRedirectWrapper {...props} component={Baggage} />} />
    <Route exact path="/:company/baggage/description" render={(props) => <VuelingRedirectWrapper {...props} component={DescriptionBaggage} />} />
    <Route exact path="/:company/baggage/confirm" render={(props) => <VuelingRedirectWrapper {...props} component={ConfirmBaggage} />} />
    <Route exact path="/:company/baggage/delivery" render={(props) => <VuelingRedirectWrapper {...props} component={DeliveryBaggage} />} />
    <Route exact path="/:company/baggage/selection" render={(props) => <VuelingRedirectWrapper {...props} component={SelectionBaggage} />} />
    <Route exact path="/:company/oops" render={(props) => <VuelingRedirectWrapper {...props} component={NotFound} />} />
    {/* </Switch> */}
  </Router>
);

export default Root;
